/**
 * 电话悬浮球(CallStatusIcon)在右下角横向占掉的宽度 —— 给整页详情的底部操作栏让位。
 *
 * 整页详情(Flyout embedded:/tasks/:id、/reservations/:id …)底部是「左主按钮 +
 * 右 ⋯」操作栏，球默认停在 right/bottom 16px，正好压住 ⋯ —— 点下去打开的是通话
 * 面板，菜单点不到。球报告自己占掉的宽度，embedded Flyout 写进
 * `--floating-ball-clearance`，操作栏的右内边距读它，把 ⋯ 让到球的左边。
 *
 * 为什么是横向让位而不是把球往上挪、或在页面底部补留白：
 *  - 往上挪会压住紧挨着操作栏的评论框 Send(实测);
 *  - 底部留白依赖页面布局 —— /reservations/:id 外层是 min-h-screen，留白只会把整个
 *    页面撑高、落到视口外(实测)。横向内边距不改变任何高度。
 *
 * 球被用户拖走、或整个通话系统未启用时报告 0(不让位)。
 * 模块级 store + useSyncExternalStore:球挂在 Layout 上，与详情页不在同一棵子树。
 */
import { useEffect, useSyncExternalStore } from 'react'

let footprint = 0
const listeners = new Set<() => void>()

function subscribe(listener: () => void) {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

const getSnapshot = () => footprint

/** 球在右下角默认落点横向占掉的宽度(px,含与视口右边缘的距离);0 = 不需要让位。 */
export function useFloatingBallFootprint(): number {
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot)
}

/** 球自己调用:挂载期间报告横向占位宽度,卸载时归零。 */
export function useReportFloatingBallFootprint(px: number): void {
  useEffect(() => {
    footprint = px
    for (const l of listeners) l()
    return () => {
      footprint = 0
      for (const l of listeners) l()
    }
  }, [px])
}
